import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import ProductsAPI from '../../api/products';

const SET_PRODUCTS_UI_FLAG = 'SET_PRODUCTS_UI_FLAG';
const SET_PRODUCTS = 'SET_PRODUCTS';
const ADD_PRODUCT = 'ADD_PRODUCT';
const EDIT_PRODUCT = 'EDIT_PRODUCT';
const DELETE_PRODUCT = 'DELETE_PRODUCT';
const SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT';

export const state = {
  records: [],
  selectedProductId: '',
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getProducts($state) {
    return $state.records;
  },
  getProductById: $state => id => {
    return $state.records.find(record => record.id === Number(id)) || {};
  },
  getSelectedProductId($state) {
    return $state.selectedProductId;
  },
  getSelectedProduct($state) {
    return (
      $state.records.find(
        record => record.id === Number($state.selectedProductId)
      ) || {}
    );
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(SET_PRODUCTS_UI_FLAG, { isFetching: true });
    try {
      const response = await ProductsAPI.get();
      commit(SET_PRODUCTS, response.data.payload);
    } finally {
      commit(SET_PRODUCTS_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, productInfo) => {
    commit(SET_PRODUCTS_UI_FLAG, { isCreating: true });
    try {
      const response = await ProductsAPI.create({ product: productInfo });
      commit(ADD_PRODUCT, response.data);
      return response.data;
    } finally {
      commit(SET_PRODUCTS_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...productInfo }) => {
    commit(SET_PRODUCTS_UI_FLAG, { isUpdating: true });
    try {
      const response = await ProductsAPI.update(id, { product: productInfo });
      commit(EDIT_PRODUCT, response.data);
      return response.data;
    } finally {
      commit(SET_PRODUCTS_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, productId) => {
    commit(SET_PRODUCTS_UI_FLAG, { isDeleting: true });
    try {
      await ProductsAPI.delete(productId);
      commit(DELETE_PRODUCT, productId);
    } finally {
      commit(SET_PRODUCTS_UI_FLAG, { isDeleting: false });
    }
  },
  setSelectedProductId({ commit }, productId) {
    commit(SET_SELECTED_PRODUCT, productId);
  },
  clearSelectedProduct({ commit }) {
    commit(SET_SELECTED_PRODUCT, '');
  },
};

export const mutations = {
  [SET_PRODUCTS_UI_FLAG]($state, uiFlag) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...uiFlag,
    };
  },
  [SET_PRODUCTS]($state, data) {
    MutationHelpers.set($state, data);
    if (
      $state.selectedProductId &&
      !data.some(product => product.id === Number($state.selectedProductId))
    ) {
      $state.selectedProductId = '';
    }
  },
  [ADD_PRODUCT]: MutationHelpers.create,
  [EDIT_PRODUCT]: MutationHelpers.update,
  [DELETE_PRODUCT]($state, productId) {
    MutationHelpers.destroy($state, productId);
    if (Number($state.selectedProductId) === Number(productId)) {
      $state.selectedProductId = '';
    }
  },
  [SET_SELECTED_PRODUCT]($state, productId) {
    $state.selectedProductId = productId ? String(productId) : '';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
